import { http } from '@/utils/http';

const baseApiUrl = '/v1/news/getListByColumnId';

// const getBaseInfo = () => {
//   return http.get(`${baseApiUrl}base-info`);
// };

const getNewsListAsync = ({ classId, page }: any) => {
  return http.get(baseApiUrl, {
    params: {
      classId,
      page,
    },
  });
};

const getLiveList = ({ page }: any) => {
  return http.get('/vote/public/controller.php?enews=live-list', {
    params: {
      classId: 4787,
      page,
    },
  });
};

const getToutiaoList = (classId: string | number) => {
  return http.get('/vote/public/controller.php?enews=news-list-top', {
    params: {
      classId,
    },
  });
};

export { getNewsListAsync, getLiveList, getToutiaoList };
